import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/common/PageHeader";
import { ExportButtons } from "@/components/common/ExportButtons";
import { DataTable } from "@/components/common/DataTable";
import { useFetch } from "@/hooks/useFetch";
import { fmtDateTime } from "@/lib/constants";

const ENTITIES = ["all", "ticket", "user", "users", "assets", "vehicles", "facilities", "documents", "work_orders", "locations", "departments", "categories", "vendors"];

export default function AuditTrail() {
  const [entity, setEntity] = useState("all");
  const { data, loading } = useFetch(`/audit-logs?limit=500${entity !== "all" ? `&entity=${entity}` : ""}`);
  const columns = [
    { key: "created_at", label: "Waktu", render: (r) => <span className="font-mono text-xs">{fmtDateTime(r.created_at)}</span> },
    { key: "actor_name", label: "Aktor", render: (r) => <span>{r.actor_name} <span className="text-xs text-muted-foreground">· {r.actor_role}</span></span> },
    { key: "action", label: "Aksi", render: (r) => <span className="rounded bg-secondary px-1.5 py-0.5 font-mono text-xs">{r.action}</span> },
    { key: "entity", label: "Entitas" }, { key: "entity_id", label: "ID", render: (r) => <span className="font-mono text-[10px] text-muted-foreground">{r.entity_id?.slice(0, 8) || "—"}</span> },
    { key: "details", label: "Detail", render: (r) => <span className="text-xs text-muted-foreground line-clamp-1 max-w-md">{JSON.stringify(r.details)}</span> },
  ];
  return (
    <div className="space-y-4 fade-up">
      <PageHeader title="Audit Trail" subtitle="Semua aksi tercatat: login, CRUD, approval, status, export.">
        <Select value={entity} onValueChange={setEntity}><SelectTrigger className="h-8 w-40" data-testid="audit-entity-filter"><SelectValue /></SelectTrigger><SelectContent>{ENTITIES.map((e) => <SelectItem key={e} value={e}>{e === "all" ? "Semua entitas" : e}</SelectItem>)}</SelectContent></Select>
        <ExportButtons collection="audit_logs" />
      </PageHeader>
      <DataTable columns={columns} rows={data || []} loading={loading} searchKeys={["actor_name", "action", "entity"]} testId="audit-table" />
    </div>
  );
}
